// extracted by mini-css-extract-plugin
export default {"button":"BHfoER","formButton":"fm4OPR","collapsed":"x5rJnP","form":"Mu7H8T","divider":"mevcI_","checkbox":"zoDHlr"};